export default __webpack_public_path__ + "static/media/twitter-rose.dcdec89a.svg";